import { render, staticRenderFns } from "./nuevoDepara.vue?vue&type=template&id=001adf6c"
import script from "./nuevoDepara.vue?vue&type=script&lang=js"
export * from "./nuevoDepara.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports